import { Reducer } from "redux";

import { ReceivedMethodMasterResponse } from "../models/Api/Patient";
import { ReceivedMethodDispatchTypes } from "../models/DispatchTypes/Patient";
import { ReceivedMethodActionDispatchTypes } from "../constants/Patient";

const initialState: ReceivedMethodMasterResponse = {
  loading: false,
  response: [],
};

const ReceivedMethodReducer: Reducer<
  ReceivedMethodMasterResponse,
  ReceivedMethodDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default ReceivedMethodReducer;
